import { type CapturedErrorTypes, errorStates } from "@hz/common/constants";

import { useSelector } from "react-redux";

import { Center, Container, VStack } from "@chakra-ui/react";

import { selectMondayState } from "@state/mondaySlice";

import API_ERROR_SCREEN from "./screens/API_ERROR";
import BOARD_NOT_CONFIGURED_SCREEN from "./screens/BOARD_NOT_CONFIGURED";
import NO_PERMISSION_SCREEN from "./screens/NO_PERMISSION";
import NO_SUBSCRIPTION_SCREEN from "./screens/NO_SUBSCRIPTION";
import SEATS_UPGRADE_REQUIRED_SCREEN from "./screens/SEATS_UPGRADE_REQUIRED";
import UNKNOWN_SCREEN from "./screens/UNKNOWN";

export default function ErrorBoundaryContent({
  type,
  onRetry,
  eventId,
}: {
  type?: CapturedErrorTypes;
  onRetry?: () => void;
  eventId?: string;
}) {
  const { context } = useSelector(selectMondayState);

  const errorDetails = `
  ${eventId ? `Error Code: ${type ? type.toUpperCase() : "UNKNOWN"}-${eventId}\n` : ""}
  ${context?.appVersion.id ? `App ID: ${context.appVersion.id}\n` : ""}
  ${context?.user.id ? `User ID: ${context.user.id}\n` : ""}
  ${context?.boardId ? `Board ID: ${context.boardId}\n` : ""}
`.trim();

  const email = "support@stackfully.co";

  const renderErrorContent = () => {
    switch (type) {
      case errorStates.NO_PERMISSION:
        return (
          <NO_PERMISSION_SCREEN
            type={type}
            eventId={eventId}
            email={email}
            errorDetails={errorDetails}
            onRetry={onRetry}
          />
        );
      case errorStates.API_ERROR:
        return (
          <API_ERROR_SCREEN
            type={type}
            eventId={eventId}
            email={email}
            errorDetails={errorDetails}
            onRetry={onRetry}
          />
        );
      case errorStates.NO_SUBSCRIPTION:
        return <NO_SUBSCRIPTION_SCREEN email={email} />;
      case errorStates.SEATS_UPGRADE_REQUIRED:
        return <SEATS_UPGRADE_REQUIRED_SCREEN email={email} />;
      case errorStates.BOARD_NOT_CONFIGURED:
        return (
          <BOARD_NOT_CONFIGURED_SCREEN
            type={type}
            eventId={eventId}
            email={email}
            errorDetails={errorDetails}
            onRetry={onRetry}
          />
        );
      default:
        return (
          <UNKNOWN_SCREEN
            type={type}
            eventId={eventId}
            email={email}
            errorDetails={errorDetails}
            onRetry={onRetry}
          />
        );
    }
  };

  return (
    <Center
      height="100vh"
      flexDirection="column"
    >
      <Container
        maxW="2xl"
        py={10}
      >
        <VStack
          textAlign="center"
          gap="25px"
        >
          {renderErrorContent()}
        </VStack>
      </Container>
    </Center>
  );
}
